import React, { PropTypes } from 'react';
import '@nois/rc-time-picker/assets/index.css';
import DateTimeField from '../TimePicker/DateTimeField';

// export default styled(TimePicker)`
//   font-weight: normal;
//   border: 1px solid #ccc;
// `;

class TimePickerInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleIconClick = this.handleIconClick.bind(this);
    this.state = {
      open: false,
    };
  }

  setOpen = ({ open }) => {
    this.setState({ open });
  };

  handleIconClick() {
    if (this.props.disabled) {
      return;
    }
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    return (
      <DateTimeField
        mode="time"
        dateTime={this.props.value}
        value={this.props.value}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        closeCallback={this.props.cb}
      />
    );
  }
}

TimePickerInput.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.any,
  disabled: PropTypes.any,
  cb: PropTypes.any,
};

export default TimePickerInput;




// WEBPACK FOOTER //
// ./app/components/TimePickerInput/index.js